import { render, staticRenderFns } from "./updatedProducts.vue?vue&type=template&id=38bb735e&scoped=true"
import script from "./updatedProducts.vue?vue&type=script&lang=js"
export * from "./updatedProducts.vue?vue&type=script&lang=js"
import style0 from "./updatedProducts.vue?vue&type=style&index=0&id=38bb735e&prod&scoped=true&lang=css"
import style1 from "./updatedProducts.vue?vue&type=style&index=1&id=38bb735e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bb735e",
  null
  
)

export default component.exports